




















import { OfferMail, Send, NoSend } from '@/api/dto/UserProfile';
import Vue, { PropType } from 'vue';

interface Data {
  offers: Array<{ name: 'send' | 'noSend', value: OfferMail, text: string }>;
}

export default Vue.extend({
  name: 'OfferMailRadioButton',
  computed: {
    current: {
      get: function(): OfferMail {
        return this.value;
      },
      set: function(val: OfferMail) {
        this.$emit('input', val);
      },
    },
  },
  props: {
    value: {
      type: String as PropType<OfferMail>,
      default: Send
    },
    disabled: Boolean,
  },
  data(): Data {
    return {
      offers: [
        { name: 'send', value: Send, text: '受信する'},
        { name: 'noSend', value: NoSend, text: '受信しない' },
      ]
    }
  }
})
